import { Component, Input, ViewContainerRef, computed, inject, input, signal, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { RegisterComponent } from '../../components/component-lookup';
import { VisualService } from '../../services/visual.service';
import { SubjectType } from '../../services/state.service';
import { GlobalConstants } from '../../../shared/global-constants';

@RegisterComponent('Kpi')
@Component({
  selector: 'app-kpi',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './kpi.component.html',
  styleUrl: './kpi.component.scss'
})
export class KpiComponent {
  @Input() value = signal<(number | null)>(null);
  dialog = viewChild.required('dialog', { read: ViewContainerRef });

  subjectType = input.required<SubjectType>();
  metricId = input.required<string>();
  displayType = input.required<string>();
  label = input.required<string>();
  tooltip = input<string>();
  highlight = input<boolean>(false);
  type = input<string>('');
  link = input<string>('');
  round = input<boolean>(true);

  colors = GlobalConstants.colors;

  private router = inject(Router);

  displayValue = computed(() => {
    const value = this.value();
    let displayType = this.displayType();

    if (displayType == 'USDMM' && value != undefined && value > 0 && value < 1000000) {
      displayType = 'USDM';
    }
    if (displayType == 'USDM' && value != undefined && value > 0 && value < 1000) {
      return VisualService.getValueDisplayOrNull(VisualService.getValue(value, 'INTEGER', 1000, 1, this.round()), 'INTEGER', this.round());
    }
    return VisualService.getValueDisplayOrNull(VisualService.getValue(value, displayType, 1000, 1, this.round()), displayType, this.round());
  });

  color = computed(() => {
    if (this.type() === 'score' || this.displayType() == 'ORDINAL') {
      const colorValue = Math.trunc(((this.value() ?? 0) / 20) + 1);
      switch (colorValue) {
        case 1:
          return 'var(--color-red)';
        case 2:
          return 'var(--color-orange)';
        case 3:
          return 'var(--color-yellow)';
        case 4:
          return 'var(--color-lime)';
        case 5:
          return 'var(--color-green)';
        default:
          return 'var(--color-grey-dark)';
      }
    } else {
      return this.highlight() ? 'white' : this.subjectType() == SubjectType.institution ? this.colors[0] : this.colors[1];
    }
  });

  backgroundColor = computed(() => {
    return this.highlight() ? (this.subjectType() == SubjectType.institution ? this.colors[0] : this.colors[1]) : 'auto';
  });

  onClick() {
    if (this.link()) {
      this.router.navigate([this.link()]);
    }
  }

}
